<template>
    <div>
        <!-- <div v-if="ajax_loader" class="checkoutLoader">
            <div class="LoaderPlacement">
                    <div class="digi-table-loader">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
            </div>
        </div> -->
        <div class="mb-3 scroll-new">
            <!-- <div v-if="ajaxCallInProgress" class="d-flex align-items-center justify-content-center w-100 mt-30">
                <hollow-dots-spinner :animation-duration="1000" :dot-size="17" :dots-num="3" color="#00448b" style="left:170px" class="text-center w-100"/>
            </div> -->
            <div class="d-flex align-items-center justify-content-center bg-white" style="height: 400px;" v-if="ajaxCallInProgress">
                <!-- <hollow-dots-spinner :animation-duration="1000" :dot-size="17" :dots-num="3" color="#00448b" style="left:170px" class="text-center w-100"/> -->
                <img class="mt-5 mb-5" src="/static/images/new-theme2024/20 card.gif" width="100" alt="digi-loader">
            </div>
            <div v-else-if="allTickets.length == 0 && !ajaxCallInProgress" style="min-height: 493px;">
                <span class="fw-500 pl-25 pt-10" style="text-align: center !important; line-height:5">No Tickets Found!</span>
            </div>
            <div v-else v-for="(ticket, list_index) in allTickets" :key="list_index">
                <div class="list-box px-4 py-2 pointer" :class="{'list-light': list_index % 2, 'highlight' : list_id_index == list_index}" @click="ticketDetails(list_index)">
                    <div class="d-flex flex-wrap justify-content-between">
                        <span class="fs-14 font-weight-bold text-black-shade">Ticket ID: {{"#" +ticket.ticket_number}}</span>
                        <span class="text-black-shade fw-500 hide-line">{{ticket.created_date}}</span>
                    </div>
                    <div class="pt-1 d-flex align-items-center justify-content-between py-2">
                        <span class="fs-14 fw-500 text-black mb-1" :title="ticket.subject" style="width: 175px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">Subject: {{ticket.subject}}</span>
                        <div class="d-flex ">
                        <span class="fs-14 fw-500 text-black mt-1 mr-1" :title="ticket.part_review_status">
                            Status:  
                        </span>
                            <button v-if="ticket.part_review_status" style="text-transform: capitalize;" class="btn btn-smm btn-default text-white btn-success-border-radius w-100px"
                                :class="{
                                        'btn-reopen-newtheme':ticket.part_review_status == 'Sent For Approval' || ticket.part_review_status == 'Review',
                                        'btn-rejected':ticket.part_review_status == 'Reject', 
                                        'btn-schedule':ticket.part_review_status == 'Scheduled',
                                        'btn-approved':ticket.part_review_status == 'Approved',
                                        'rejected-btn':ticket.part_review_status == 'Rejected'}">
                                {{ticket.part_review_status}}
                            </button>
                        </div>
                    </div>
                    <div class="d-flex justify-content-between">
                        <!-- <span class="text-black fw-400" :title="ticket.assigned_to" style="width: 175px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">Assigned To: {{ticket.assigned_to || '-'}}</span> -->
                        <!-- <span class="text-black-shade fw-500 mr-2" v-if="ticket.template_type == 'default'" :title="ticket.assigned_to" style="max-width: 175px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">Assigned To: {{ticket.assigned_to || '-'}}</span> -->
                        <!-- <span class="text-black-shade fw-500 mr-2" v-if="ticket.template_type == 'multi_part'" :title="ticket.assigned_to" style="max-width: 175px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">Approver: {{ ticket.approve_data[0].name || '-' }}</span> -->
                        <span class="text-black-shade fw-500 mr-2"  :title="ticket.assigned_to" style="max-width: 175px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                            Approvers: 
                            <span v-for="(approver, index) in ticket.approve_data" :key="approver.id">
                                {{ approver.name }}<span v-if="index < ticket.approve_data.length - 1">, </span>
                            </span>
                        </span>
                        <span class="text-black fw-400 hide-line" :title="ticket.created_by" style="width: 175px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">Creator:  {{ticket.created_by || '-'}}</span>
                    </div>
                </div>
            </div>
        </div>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </div>
</template>

<script>
import ticket from '../mixins/ticket.js';
import Swal from 'sweetalert2';
import {SweetModal} from 'sweet-modal-vue';
import { EventBus } from '../eventBus/nav-bar-event.js';
export default{
    mixins: [ticket],
    props: ["getSkipCount", "pagination", "list_id_index", "allTickets", "ajaxCallInProgress"],
    data(){
        return {
            passed_key:{
                key: '',
                value: ''
            },
            skip:0,
            limit:10,
            total:0,
            temp_total:0,
            skip_temp: 0,
            ticket_details: {
                ticket_id: '',
                part_name: ''
            },
            
        }
    },
    methods: {
        ticketDetails(index){
            this.$emit('getReviewTicketDetails', index)
        },
        createTickets() {
            let ticket ={
                ticket_id:'',
                ticket_number:''
            }
            localStorage.setItem("parentTicketDetails", JSON.stringify(ticket))
            this.$router.push({ name: "TicketsCreate" });
        },
        setPasskey(){

        }
    },
    computed:{
        loggedInUser() {
            return this.$store.state.store.loggedInUser
        },
    },
    mounted(){
        // EventBus.$on("callTicketList", ()=>{
        //     this.getReviewTicketAPI();
        // })
        // this.getReviewTicketAPI()
    },
    created(){

    }
}
</script>

<style scoped>
.list-box {
    width: 100%;
    object-fit: contain;
    border-radius: 5px;
    box-shadow: 0 1.5px 3px 0 rgba(0, 0, 0, 0.16);
    border: solid 0.5px #f3f6fb;
    background-color: #f3f6fb;
}
.list-box:hover {
    width: 100%;
    object-fit: contain;
    border-radius: 5px;
    box-shadow: 0 1.5px 3px 0 rgba(0, 0, 0, 0.16);
    border: solid 0.5px #f3f6fb;
    background-color: #d5e2fa;
}
.list-light {
    width: 100%;
    object-fit: contain;
    border-radius: 5px;
    box-shadow: 0 1.5px 3px 0 rgba(0, 0, 0, 0.16);
    border: solid 0.5px #f3f6fb;
    background-color: #ffffff;
}
.text-black{
    color: #363636 !important;
}
.scroll-new{
    overflow-y: scroll;
    width: 100%;
    height: fit-content;
}

.list-light {
    width: 100%;
    object-fit: contain;
    border-radius: 5px;
    box-shadow: 0 1.5px 3px 0 rgba(0, 0, 0, 0.16);
    border: solid 0.5px #f3f6fb;
    background-color: #ffffff;
}

.highlight{
    background-color: #d5e2fa !important;
}
@media (max-width: 1100px) {
    .hide-line{
        display: none;
    }
}
</style>